import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { SizingDialogMode } from 'src/app/models/sizing';
import { translate } from '@jsverse/transloco';

@Component({
  selector: 'app-sizing-confirm-dialog',
  templateUrl: './sizing-confirm-dialog.component.html',
  styleUrl: './sizing-confirm-dialog.component.scss',
  standalone: false
})
export class SizingConfirmDialogComponent  {

  selectedSize: string;
  mode!: SizingDialogMode;
  nameSuffix?: string;
  SizingDialogMode = SizingDialogMode;
  documentNameControl!: FormControl;
  sizeError: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SizingConfirmDialogComponent>, private formBuilder: FormBuilder
  ) {
    
      this.mode = data?.mode;
      this.nameSuffix = data?.nameSuffix;      
      this.selectedSize = 'XXS-Small';

      this.documentNameControl = new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(32),
        Validators.pattern(/^([A-Za-z])([a-zA-Z0-9_])+( [a-zA-Z0-9_]+)*$/)
      ]);

      this.documentNameControl.setValue(data?.documentName || '');

      if (this.mode === SizingDialogMode.CREATE_WITH_EXISTING || data?.disableName) {
        this.documentNameControl.disable();
      } else {
        this.documentNameControl.enable();
      }
  }

  onSizeChange(event: any): void {
  const value = event.target.value;

  if (value !== 'XXS-Small') {
    this.sizeError = translate('SIZING.SUPPORTED_SIZE');
    this.dialogRef.updateSize('566px', '420px');
  } else {
    this.sizeError = '';
    this.dialogRef.updateSize('566px', '400px');
  }

  this.selectedSize = value;
}

  private duplicateValidator(existingNames: string[]) {
  return (control: FormControl) => {
    if (!control.value) return null;

    const normalized = control.value.toLowerCase().trim();
    return existingNames.includes(normalized)
      ? { duplicate: true }
      : null;
  };
}

get isReadOnlyMode(): boolean {
  return this.mode === SizingDialogMode.CREATE_WITH_EXISTING || !!this.data?.disableName;
}


  confirm(): void {
    if (!this.isReadOnlyMode && this.documentNameControl.invalid) {
      this.documentNameControl.markAllAsTouched();
      return;
    }

    const inputValue = this.documentNameControl.getRawValue()?.trim();
    const name = this.nameSuffix ? `Sizing_${inputValue}${this.nameSuffix}` : inputValue;
    this.dialogRef.close({
      documentName: name,
      environmentSize: this.selectedSize,
      mode: this.mode
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
